import React from 'react';
import { GoStarFill } from "react-icons/go";
const ReviewForm = () => {
  // const [name, setName] = useState('');
  // const [review, setReview] = useState('');
  // const [submitted, setSubmitted] = useState(false);

  // const handleSubmit = (event) => {
  //   event.preventDefault();
    
  //   // Normalmente qui invieresti i dati a un server, ma in queshref caso,
  //   // redirigeremo l'utente alla pagina di recensioni di Google
  //   setSubmitted(true);
  // };


  
  return (
    <div className="flex flex-col justify-center items-center p-4">
      <h1 className='text-3xl font-bold text-center pb-4'>Lascia una recensione positiva!</h1>
      <p className='font-semibold p-4 text-center'> La tua opinione è molto importante per noi, poiché ci aiuta a migliorare continuamente i nostri servizi e a garantire la migliore qualità ai nostri clienti.</p>

      <div className='w-full flex items-center justify-center p-4' >
        <div className='bg-logo-color4  text-white md:w-1/3 rounded-lg shadow-lg px-6 py-3'>
            <div className='flex items-center justify-center space-x-5 text-logo-color text-3xl p-4'>
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            <GoStarFill />
            </div>
            

        </div>
      </div>

      <p className='p-4 text-center font-semibold'>Se ti sei trovato bene con il nostro lavoro e i nostri serramenti hanno migliorato la sicurezza e lo stile della tua casa, 
       <br /> ti saremmo grati se potessi dedicarci qualche minuto per lasciare una recensione positiva.</p>
        <p className='p-4 text-center font-bold border-2 border-logo-color rounded-xl '>Il tuo feedback è prezioso e ci aiuta a crescere!</p>
    </div>
  );
};

export default ReviewForm;
